var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMvuLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 40,
    viewBox: "0 0 94 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0695 0.506329H19.6043L25.6364 25.8228L39.7112 0L47.754 40H39.7112V11.1392L24.631 40H22.6203L16.0856 10.1266L7.03743 40H0L13.0695 0.506329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2674 25.8228L45.7433 0.506329H62.3316L50.2674 25.8228Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8182 19.2405L68.8663 0L66.3529 19.2405C66.1854 21.7722 65.3476 27.443 65.3476 29.8734C65.3476 32.9114 68.3636 34.4304 70.877 34.4304H77.9144C82.9412 34.4304 83.4439 29.3671 83.9465 27.3418L87.9679 0.506329H94C93.5979 6.58228 91.1515 22.9536 89.9786 30.3797C88.859 37.4684 83.6449 40 78.1155 40H69.8717C63.0353 40 58.8128 34.9367 59.3155 30.3797L59.8182 19.2405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvuLogoWhite);
export default __webpack_public_path__ + "static/media/MVULogoWhite.dc373bbd83e278f76b4d958461f08266.svg";
export { ForwardRef as ReactComponent };